import { useMemo } from "react";
import utils from "../../Utils";
import ServiceMapper from "../../mappers/ServiceMapper";
import Service from "../../models/domain/Service";
import Path, { StringMap } from "../../models/ui/Path";
import useRemoteResource from "../remoteResource/useRemoteResource";
import { ServiceListResponse } from "../../models/serviceApi/ServiceResponse";

export default function useServiceList(query: StringMap = {}) {
  const userProfile = utils.retrieveUserProfile();

  const path = useMemo(() => {
    if (!userProfile?.clinicId) return null;

    return new Path(
      ["api", "v1", "clinics", userProfile.clinicId, "services"],
      query,
    ).toString();
  }, [userProfile?.clinicId, query]);

  const { resource, error, isLoading, refresh } =
    useRemoteResource<ServiceListResponse>(path);

  const mappedServices: Service[] | undefined = useMemo(() => {
    if (!resource?.services) return undefined;
    return ServiceMapper.mapList(resource.services);
  }, [resource]);

  return {
    services: mappedServices,
    isLoading,
    error,
    refresh,
  };
}
